import { TRole } from '../pages/auth/interfaces';
import { menuConfigItems } from '../constants/menuConfigItems';

const {
  profile,
  usersManager,
  users,
  legal,
  settings,
  catalog,
  guestBlog,
  chats,
} = menuConfigItems;

const getDefaultMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [profile],
  },
});

const getManagerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [usersManager, chats, profile],
  },
});

const getAdminMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [users, settings, legal, chats],
  },
});

// const getVendorMenu = () => ({
//   header: {
//     self: {},
//     items: [],
//   },
//   aside: {
//     self: {},
//     items: [profile, logout],
//   },
// });

// const getBuyerMenu = () => ({
//   header: {
//     self: {},
//     items: [],
//   },
//   aside: {
//     self: {},
//     items: [profile, logout],
//   },
// });

const getGuestMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [catalog, guestBlog],
  },
});

const getMenuConfig = (userRoles: TRole[] = ['ROLE_BUYER'], isAuthorized?: boolean) => {
  if (isAuthorized) {
    if (userRoles && userRoles.includes('ROLE_ADMIN')) {
      return getAdminMenu();
    }
    if (userRoles && userRoles.includes('ROLE_MANAGER')) {
      return getManagerMenu();
    }
    return getDefaultMenu();
  }
  return getGuestMenu();
};

export default getMenuConfig;
